import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination, Keyboard } from 'swiper/modules';
import { Container, Row, Col, Button } from 'react-bootstrap';

import 'swiper/css';
import 'swiper/css/pagination';
import 'animate.css';

import './App.css';

import { BarChart3, Camera, Code, Code2, Fingerprint, Funnel, GraduationCap, Heart, Map, Palette, Radar, Share2, Video, Videotape, Mail, MessageCircle, Globe, Instagram, Linkedin, UserCircle, Facebook, ArrowRight, Hand } from 'lucide-react';

import logo from './img/eurekalogo.png'
import ParticlesBackground from './ParticlesBackground';

function Home() {

  const SERVICES = [
    {
      title: 'Growth Marketing:',
      desc: 'Embudos de venta y automatización con Chatbots.',
      icon: <Funnel />,
      color0: '#2e1a47',
      color1: '#432b6d',
      color2: '#a855f7',
      cols: 4
    },
    {
      title: 'Social Media:',
      desc: 'Gestión estratégica de redes y creación de contenido dinámico.',
      icon: <Share2 />,
      color0: '#1c0e45',
      color1: '#232b55',
      color2: '#3c82f6',
      cols: 4
    },
    {
      title: 'Visual Craft:',
      desc: 'Diseño gráfico digital y fotografía de producto de alto nivel.',
      icon: <Palette />,
      color0: '#3b210f',
      color1: '#4f3929',
      color2: '#fcbf24',
      cols: 4
    },
    {
      title: 'Tech & Video:',
      desc: 'Desarrollo web/apps y producción de video para TikTok, Reels y YouTube.',
      icon: <Video />,
      color0: '#3c131f',
      color1: '#4d1d2b',
      color2: '#ef4444',
      cols: 8
    },
    {
      title: 'Mentoring:',
      desc: 'Capacitación y cursos especializados.',
      icon: <GraduationCap />,
      color0: '#3f1a47',
      color1: '#552b6d',
      color2: '#d455f7',
      cols: 4
    }
  ]

  const METODOLOGIA = [
    { icon: <Fingerprint size={24} />, title: "ADN", desc: "Entendemos a fondo tus valores y la esencia de tu marca." },
    { icon: <Radar size={24} />, title: "Radar", desc: "Analizamos el mercado y a tu competencia." },
    { icon: <Map size={24} />, title: "Mapa", desc: "Diseñamos la estrategia y elegimos los canales ideales." },
    { icon: <Heart size={24} />, title: "Vínculo", desc: "Creamos contenido de valor que genera conexiones reales." },
    { icon: <BarChart3 size={24} />, title: "Eco", desc: "Análisis de datos y reportes para mejora continua." }
  ];

  const EXPERIENCIA = [
    { icon: <Palette size={24} />, title: "Diseño Gráfico", desc: "Desde logotipos, flyers digitales, contenidos y hasta identidad completa para redes sociales." },
    { icon: <Code size={24} />, title: "Web & Apps", desc: "Desarrollamos sitios y apps a la medida con navegación intuitiva. Optimizamos tu presencia con bases sólidas de SEO. El objetivo es que tus clientes encuentren todo sobre ti de forma fácil y rápida." },
  ];

  const CONTENIDO = [
    { icon: <Camera size={24} />, title: "Fotografía de Producto", desc: "Capturamos la esencia de lo que vendes con el mejor ángulo, sin excesos de edición. Hemos fotografiado desde productos miniatura hasta aviones.", link: 'https://digital-eureka.com/fotografia-producto/' },
    { icon: <Video size={24} />, title: "Producción de Video", desc: "Contamos tu historia de forma dinámica para las plataformas más actuales. Desarrollo de guiones estratégicos. Postproducción adaptada al giro de tu negocio." },
  ];

  return (
    <>
      <div>
        <Swiper
          direction={'vertical'}
          slidesPerView={1}
          spaceBetween={0}
          mousewheel={true}
          keyboard={{ enabled: true }}
          pagination={{ clickable: true, dynamicBullets: true }}
          speed={1000}
          modules={[Mousewheel, Pagination, Keyboard]}
          style={{ height: '100vh', width: '100%' }}
          className="bg-mesh"
          autoHeight={true}
        >

          {/* SLIDE 1 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex align-items-center justify-content-center">
              <Row className="w-100 text-center">
                <Col>
                  <main className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center relative overflow-hidden">
                    <Container className="slide-container">

                      <div className='mb-3 reveal-text'>
                        <img src={logo} className='logo-agency' alt="Logo" />
                      </div>

                      <div className='hero-subtext reveal-text delay-1 mb-2'
                        style={{ letterSpacing: '2px', textTransform: 'uppercase', fontSize: '1.2rem' }}>
                        Agencia digital
                      </div>

                      <div className="text-gradient reveal-text delay-2 fw-bold mb-4"
                        style={{ lineHeight: '1.1' }}>
                        Hagamos que tus ideas sucedan
                      </div>

                      <div className='d-flex justify-content-center mb-4'>
                        <div className="hero-desc reveal-text delay-3" style={{ maxWidth: '700px' }}>
                          Somos un grupo de profesionistas apasionados y expertos en plataformas de marketing digital. Nuestro objetivo es claro: ayudar a emprendedores y empresarios a escalar sus negocios.
                        </div>
                      </div>

                      <div className="mb-5 reveal-text delay-4">
                        <span className="badge-innovation">
                          Tu Partner Estratégico
                        </span>
                      </div>

                    </Container>
                  </main>
                </Col>
              </Row>
            </Container>
          </SwiperSlide>

          {/* SLIDE 2 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex flex-column justify-content-center slide-container p-4">

              {/* Encabezado de la Slide */}
              <Row className="w-100 align-items-center mb-5">
                <Col>
                  <div className='hero-subtext reveal-text serv-title mb-2' style={{ letterSpacing: '2px' }} >
                    Soluciones
                  </div>
                  <div className="text-subgradient reveal-text delay-1 fw-bold mb-4">
                    Integrales 360°
                  </div>
                  <div className="hero-desc reveal-text delay-2">
                    Creamos soluciones a través de medios digitales con estrategias que rompen el molde.
                  </div>
                </Col>
              </Row>

              <Row className="g-4 horizontal-mobile-scroll">
                {SERVICES.map((item, index) => (
                  <Col
                    md={item.cols}
                    xs={12}
                    key={'ser-' + index}
                    className="d-flex align-items-stretch"
                  >
                    <div
                      className="custom-card h-100 w-100 reveal-text"
                      style={{
                        backgroundColor: item.color0,
                      }}
                    >
                      <div className="icon-wrapper" style={{ backgroundColor: item.color1 }}>
                        <span className="material-symbols-outlined custom-icon" style={{ color: item.color2 }}>
                          {item.icon}
                        </span>
                      </div>

                      <h3 className="card-title">{item.title}</h3>
                      <p className="card-description mt-2">
                        {item.desc}
                      </p>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className="scroll-indicator d-md-none">
                <div className="scroll-hand">
                  <span className="material-symbols-outlined"><Hand /></span>
                </div>
                <span className="scroll-text">Desliza para ver más</span>
              </div>
            </Container>
          </SwiperSlide>

          {/* SLIDE 3 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex flex-column justify-content-center slide-container">
              <Container className='bg-serv' style={{ position: 'relative', overflow: 'hidden' }}>

                <div className="bg-icon-floating reveal-img">
                  <Share2 size={280} strokeWidth={1} />
                </div>

                <Container className="position-relative" style={{ zIndex: 2 }}>
                  <Row className="w-100 align-items-center mb-5">
                    <Col md={10}>
                      <div className='hero-subtext reveal-text serv-title-ind' style={{ letterSpacing: '2px' }} >
                        Tu Marca
                      </div>
                      <div className="text-services reveal-text delay-1 fw-bold mb-4">
                        en Movimiento
                      </div>
                      <div className="hero-desc reveal-text delay-2">
                        Tu tiempo es valioso; mientras tú operas tu negocio, nosotros construimos tu comunidad.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md={12}>
                      <div className='serv-subtitle reveal-text delay-3 mb-4'>Nuestra metodología:</div>

                      <Row className="g-4 horizontal-mobile-scroll">
                        {METODOLOGIA.map((item, index) => (
                          <Col
                            md={6}
                            xs={6}
                            key={index}
                            className="d-flex align-items-stretch"
                          >
                            <div
                              className="method-item d-flex align-items-start gap-3 h-100 w-100 reveal-text"
                              style={{ transitionDelay: `${(index + 5) * 0.1}s` }}
                            >
                              <div className="method-icon-container">
                                {item.icon}
                              </div>
                              <div>
                                <strong className="method-title d-block">{item.title}</strong>
                                <span className="method-desc">{item.desc}</span>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>

                      <div className="scroll-indicator d-md-none">
                        <div className="scroll-hand">
                          <span className="material-symbols-outlined"><Hand /></span>
                        </div>
                        <span className="scroll-text">Desliza para ver más</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </Container>
          </SwiperSlide>

          {/* SLIDE 4 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex flex-column justify-content-center slide-container">
              <Container className='bg-serv' style={{ position: 'relative', overflow: 'hidden' }}>

                <div className="bg-icon-floating reveal-img">
                  <Code2 size={280} strokeWidth={1} />
                </div>

                <Container className="position-relative" style={{ zIndex: 2 }}>
                  <Row className="w-100 align-items-center mb-5">
                    <Col md={10}>
                      <div className='hero-subtext reveal-text serv-title-ind mb-2' style={{ letterSpacing: '2px' }} >
                        Experiencia Digital
                      </div>
                      <div className="text-services reveal-text delay-1 fw-bold mb-4">
                        Inmersiva
                      </div>
                      <div className="hero-desc reveal-text delay-2">
                        Transformamos la interacción en resultados, utilizando tecnología de punta para conectar con tu audiencia.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md={12}>
                      <Row className="g-4 horizontal-mobile-scroll">
                        {EXPERIENCIA.map((item, index) => (
                          <Col
                            md={12}
                            key={index}
                            className="d-flex align-items-stretch"
                          >
                            <div
                              className="method-item d-flex align-items-start gap-3 h-100 w-100 reveal-text"
                              style={{ transitionDelay: `${(index + 4) * 0.15}s` }}
                            >
                              <div className="method-icon-container">
                                {item.icon}
                              </div>
                              <div>
                                <strong className="method-title d-block">{item.title}</strong>
                                <span className="method-desc">{item.desc}</span>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>

                      <div className="scroll-indicator d-md-none">
                        <div className="scroll-hand">
                          <span className="material-symbols-outlined"><Hand /></span>
                        </div>
                        <span className="scroll-text">Desliza para ver más</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </Container>
          </SwiperSlide>

          {/* SLIDE 5 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex flex-column justify-content-center slide-container">
              <Container className='bg-serv' style={{ position: 'relative', overflow: 'hidden' }}>

                <div className="bg-icon-floating reveal-img">
                  <Videotape size={280} strokeWidth={1} />
                </div>

                <Container className="position-relative" style={{ zIndex: 2 }}>
                  <Row className="w-100 align-items-center mb-5">
                    <Col md={10}>
                      <div className='hero-subtext reveal-text serv-title-ind mb-2' style={{ letterSpacing: '2px' }} >
                        Contenido que
                      </div>
                      <div className="text-services reveal-text delay-1 fw-bold mb-4">
                        Enamora
                      </div>
                      <div className="hero-desc reveal-text delay-2">
                        Transformamos ideas en piezas visuales que conectan emocionalmente con tu audiencia y elevan el valor de tu marca.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md={12}>
                      <Row className="g-4 horizontal-mobile-scroll">
                        {CONTENIDO.map((item, index) => (
                          <Col
                            md={12}
                            key={index}
                            className="d-flex align-items-stretch"
                          >
                            <div
                              className="method-item d-flex align-items-start gap-3 h-100 w-100 reveal-text"
                              style={{ transitionDelay: `${(index + 4) * 0.15}s` }}
                            >
                              <div className="method-icon-container">
                                {item.icon}
                              </div>
                              <div className='flex-grow-1'>
                                <strong className="method-title d-block">{item.title}</strong>
                                <span className="method-desc">{item.desc}</span>
                              </div>
                              {item.link &&
                                <div className='d-flex align-items-center align-self-center'>
                                  <a href={item.link} style={{ color: '#fff' }}><ArrowRight /></a>
                                </div>
                              }
                            </div>
                          </Col>
                        ))}
                      </Row>

                      <div className="scroll-indicator d-md-none">
                        <div className="scroll-hand">
                          <span className="material-symbols-outlined"><Hand /></span>
                        </div>
                        <span className="scroll-text">Desliza para ver más</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </Container>
          </SwiperSlide>

          {/* SLIDE 6 */}
          <SwiperSlide style={{ color: 'white' }}>
            <Container className="h-100 d-flex flex-column justify-content-center slide-container">

              <div className="mb-5 text-center">
                <div className="text-contact reveal-text fw-bold"
                  style={{ lineHeight: '1' }}>
                  ¡Hagamos Eureka!
                </div>
                <div className="hero-subtext contacto-sub reveal-text delay-1 mt-3"
                  style={{ letterSpacing: '3px', textTransform: 'uppercase', opacity: 0.8 }}>
                  El momento de tu marca es ahora
                </div>
              </div>

              <Row className="justify-content-center">
                <Col lg={8} md={10}>
                  <div className="contact-card reveal-text delay-2">
                    <Row className="g-4 align-items-center">

                      <Col md={6} className="text-md-start border-end-custom">
                        <div className="d-flex align-items-center gap-3 mb-4">
                          <div className="profile-icon-wrapper">
                            <UserCircle size={40} className="text-primary-vibrant" />
                          </div>
                          <div>
                            <h4 className="mb-0 fw-bold" style={{ letterSpacing: '1px' }}>Pablo Monroy</h4>
                            <span className="small text-uppercase">Director</span>
                          </div>
                        </div>

                        <div className="contact-info-list">
                          <a href="mailto:pablo@digital-eureka.com" className="contact-link" target='_blank'>
                            <Mail size={18} /> pablo@digital-eureka.com
                          </a>
                          <a href="https://wa.me/525543473835" className="contact-link" target='_blank'>
                            <MessageCircle size={18} /> 55 4347 3835
                          </a>
                          <a href="https://www.digital-eureka.com" className="contact-link" target="_blank" rel="noreferrer">
                            <Globe size={18} /> digital-eureka.com
                          </a>
                        </div>
                      </Col>

                      {/* Redes Sociales y Acción */}
                      <Col md={6} className="text-center">
                        <div className='mb-3 reveal-text'>
                          <img src={logo} className='logo-footer' alt="Logo" />
                        </div>
                        <p className="mb-3 small fw-bold text-uppercase" style={{ letterSpacing: '2px', opacity: 0.6 }}>
                          Conectemos
                        </p>
                        <div className="d-flex justify-content-center gap-4 mb-2">
                          <a href="https://www.instagram.com/eureka_marketing/" target='_blank' className="social-btn-link">
                            <span className="social-btn-circle"><Instagram size={22} /></span>
                          </a>
                          <a href="https://www.facebook.com/SomosEureka" target='_blank' className="social-btn-link">
                            <span className="social-btn-circle"><Facebook size={22} /></span>
                          </a>
                        </div>
                      </Col>

                    </Row>
                  </div>
                </Col>
              </Row>

              {/* Footer opcional muy discreto */}
              <div className="mt-5 text-center reveal-text delay-4" style={{ opacity: 0.3, fontSize: '0.7rem' }}>
                © {new Date().getFullYear()} Eureka. Todos los derechos reservados.
              </div>

            </Container>
          </SwiperSlide>

        </Swiper>
      </div >
    </>
  );
}

export default Home;
